import { render, staticRenderFns } from "./SlidebarCustom.vue?vue&type=template&id=3fbfabeb&scoped=true"
import script from "./SlidebarCustom.vue?vue&type=script&lang=js"
export * from "./SlidebarCustom.vue?vue&type=script&lang=js"
import style0 from "./SlidebarCustom.vue?vue&type=style&index=0&id=3fbfabeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfabeb",
  null
  
)

export default component.exports